/* eslint-disable dot-notation */
/* eslint-disable react-hooks/rules-of-hooks */

import { useContext } from "react";
import { useQuery } from "react-query";
import { LocaleContext } from "../localization/LanguageProvider";
import { axiosInstance } from "./AxiosConfig";
import { AuthContext } from "../../auth/AuthProvider";

export const CallAPI = ({
  name,
  method = "get",
  body,
  query,
  url,
  baseURL,
  headers,
  cacheTime,
  enabled = true,
  initialData,
  initialDataUpdatedAt,
  isDataEqual,
  keepPreviousData,
  meta,
  notifyOnChangeProps,
  notifyOnChangePropsExclusions,
  onError,
  onSettled,
  onSuccess,
  queryKeyHashFn,
  refetchInterval,
  refetchIntervalInBackground,
  refetchOnMount,
  refetchOnReconnect,
  refetchOnWindowFocus,
  retry = false,
  retryOnMount,
  retryDelay,
  select,
  staleTime,
  structuralSharing,
  suspense,
  useErrorBoundary,
}) => {
  const { user } = useContext(AuthContext);
  const { locale } = useContext(LocaleContext);

  return useQuery(
    name,
    () =>
      axiosInstance({
        url,
        data: body,
        method,
        headers: {
          "Accept-Language": locale || "ar",
          Authorization: user?.token ? `Bearer ${user?.token}` : null,
          ...headers,
        },
        params: query,
        baseURL,
      }),
    {
      cacheTime,
      enabled,
      initialData,
      initialDataUpdatedAt,
      isDataEqual,
      keepPreviousData,
      meta,
      notifyOnChangeProps,
      notifyOnChangePropsExclusions,
      onError,
      onSettled,
      onSuccess,
      queryKeyHashFn,
      refetchInterval,
      refetchIntervalInBackground,
      refetchOnMount,
      refetchOnReconnect,
      refetchOnWindowFocus,
      retry,
      retryOnMount,
      retryDelay,
      select,
      staleTime,
      structuralSharing,
      suspense,
      useErrorBoundary,
    }
  );
};
